//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			show: false,
		};
	},

	props: {
		contact: {},
		linkedIn: {},
		linkedInLogo: {},
		profile: {},
		privacy: {},
		facebookLogo: {},
		facebookUrl: {},
		instaLogo: {},
		instaUrl: {},
		raaLogo: {},
		raaUrl: {},
	},

	computed: {
		getTheYear() {
			var d = new Date();
			var n = d.getFullYear();
			return n;
		},
	},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/SiteFooter.vue